/**
 * A class to handle the mobile account navigation.
 */
class MobileAccountNav {
    constructor() {
        // Assign variables
        this.body = document.body;
        this.siteHeader = this.body.querySelector('.header-new__top');
        this.slidingAccountNavPanel = this.body.querySelector('.sliding-account-nav-panel');
        this.profileIcon = this.body.querySelector('.profile-icon');
        this.isAccountPage = this.body.classList.contains('woocommerce-account');
        this.isAccountMenuVisible = false;

        this.handleProfileIconClick = this.handleProfileIconClick.bind(this);
        this.closeAccountMenu = this.closeAccountMenu.bind(this);

        // Add event listeners
        this.addEventListeners();
    }

    addEventListeners() {
        this.profileIcon.addEventListener('click', this.handleProfileIconClick);
    }

    handleProfileIconClick(event) {
        if (!this.isAccountPage) {
            return;
        }
        event.preventDefault();

        if (this.isAccountMenuVisible) {
            // Close the menu
            this.closeAccountMenu();
            console.log('Closing menu');
        } else {
            // Open the menu
            this.openAccountMenu();
            console.log('Opening menu');
        }
    }

    // Close the menu
    closeAccountMenu() {
        this.isAccountMenuVisible = false;
        this.slidingAccountNavPanel.classList.remove('open');
        this.body.style.overflow = 'auto';
    }

    openAccountMenu() {
        this.isAccountMenuVisible = true;
        this.slidingAccountNavPanel.classList.add('open');
        this.body.style.overflow = 'hidden';

        const closeAccountNav = this.slidingAccountNavPanel.querySelector('.close-account-nav');
        closeAccountNav.addEventListener('click', () => {
            this.closeAccountMenu()
        });
    }
}

// Initialize the menu handler
if (!document.body.classList.contains('page-template-page-landingpage') && !document.body.classList.contains('woocommerce-checkout')) {
    const MobileAccountNavInstance = new MobileAccountNav();
}

if(document.body.classList.contains('woocommerce-account') && document.querySelector('.loyalty-slider')) {
    document.addEventListener('DOMContentLoaded', () => {
        const el = document.querySelector('.loyalty-slider');
        let menuAdded = false;
        const swiperHTML = `
            <div class="swiper-nav">
                <div class="swiper-pagination"></div>
                <div class="swiper-buttons">
                    <div class="swiper-button-prev"><svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.86103 12.4352L24.8697 12.4353C25.1694 12.4353 25.4569 12.3162 25.6689 12.1042C25.8809 11.8922 26 11.6047 26 11.3049C26 11.0051 25.8809 10.7176 25.6689 10.5056C25.4569 10.2936 25.1694 10.1746 24.8697 10.1746L3.86103 10.1746L12.1058 1.93207C12.318 1.71982 12.4373 1.43195 12.4373 1.13178C12.4373 0.831615 12.318 0.543744 12.1058 0.331495C11.8935 0.119246 11.6057 6.21947e-06 11.3055 6.19323e-06C11.0053 6.16699e-06 10.7175 0.119246 10.5052 0.331494L0.332084 10.5046C0.226818 10.6096 0.143303 10.7344 0.0863186 10.8717C0.0293345 11.009 2.29346e-06 11.1562 2.28046e-06 11.3049C2.26746e-06 11.4536 0.0293344 11.6008 0.0863185 11.7381C0.143303 11.8755 0.226818 12.0002 0.332083 12.1052L10.5052 22.2783C10.7175 22.4906 11.0053 22.6098 11.3055 22.6098C11.6057 22.6098 11.8935 22.4906 12.1058 22.2783C12.318 22.0661 12.4373 21.7782 12.4373 21.478C12.4373 21.1779 12.318 20.89 12.1058 20.6777L3.86103 12.4352Z" fill="currentColor"/></svg></div>
                    <div class="swiper-button-next"><svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.139 10.1746L1.13035 10.1746C0.83056 10.1746 0.543052 10.2937 0.331071 10.5057C0.11909 10.7177 0 11.0052 0 11.305C0 11.6047 0.11909 11.8923 0.331071 12.1042C0.543052 12.3162 0.83056 12.4353 1.13035 12.4353L22.139 12.4353L13.8942 20.6778C13.682 20.89 13.5627 21.1779 13.5627 21.4781C13.5627 21.7782 13.682 22.0661 13.8942 22.2784C14.1065 22.4906 14.3943 22.6099 14.6945 22.6099C14.9947 22.6099 15.2825 22.4906 15.4948 22.2784L25.6679 12.1052C25.7732 12.0002 25.8567 11.8755 25.9137 11.7382C25.9707 11.6009 26 11.4536 26 11.305C26 11.1563 25.9707 11.0091 25.9137 10.8717C25.8567 10.7344 25.7732 10.6097 25.6679 10.5047L15.4948 0.33155C15.2825 0.119301 14.9947 6.10352e-05 14.6945 6.10352e-05C14.3943 6.10352e-05 14.1065 0.119301 13.8942 0.33155C13.682 0.543799 13.5627 0.83167 13.5627 1.13184C13.5627 1.432 13.682 1.71987 13.8942 1.93212L22.139 10.1746Z" fill="currentColor"/></svg></div>
                </div>
            </div>`;
    
        function initSwiper() {
			const screenWidth = window.innerWidth
			if (screenWidth <= 768) {
				if (el && !el.swiper) {
					if (!menuAdded) {
						const tempDiv = document.createElement('div')
						tempDiv.className = 'swiper-nav-wrapper'
						tempDiv.innerHTML = swiperHTML
						el.appendChild(tempDiv)
						menuAdded = tempDiv
					}

					el.swiper = new Swiper(el, {
						slideClass: 'product',
						slidesPerView: 'auto',
						spaceBetween: 10,
						observer: true,
						pagination: {
							el: '.swiper-pagination',
							type: 'bullets',
							clickable: true
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev'
						},
						breakpoints: {
							576: { slidesPerView: 2 }
						}
					})
				}
			} else {
				if (el && el.swiper) {
					el.swiper.destroy()
					el.swiper = null
				}

				if (menuAdded) {
					menuAdded.remove()
					menuAdded = false
				}
			}
		}
    
        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
}


// if (document.body.classList.contains('woocommerce-account')) {
//     // My Account Mobile Navigation
//     const accountNav = document.getElementById('account-navigation');
//     const accountIcon = document.querySelector('.profile-icon');
//     const footer = document.getElementById('site-footer');

//     if (accountNav) {
//         function handleMobileNavigation() {
//             if (window.innerWidth < 992) {
//                 accountIcon.addEventListener('click', function (e) {
//                     e.preventDefault();
//                     accountNav.classList.toggle('show-nav');
//                     document.body.classList.toggle('mobile-menu-active');
//                     footer.classList.toggle('stacking-hack');
                    
//                 });
//             } else {
//                 accountNav.classList.remove('show-nav');
//                 document.body.classList.remove('mobile-menu-active');
//                 footer.classList.remove('stacking-hack');
//             }
//         }

//         handleMobileNavigation();
//         window.addEventListener('resize', handleMobileNavigation);
//     }


//     function handleScroll(e) {
//         const accountNav = document.getElementById('account-navigation');
//         const siteHeader = document.getElementById('site-header');
//         let siteHeaderBottom = siteHeader.getBoundingClientRect().bottom;
        
//         accountNav.style.top = siteHeaderBottom + 'px';
//     }
//     // handleScroll();
//     // window.addEventListener('scroll', handleScroll, { passive: true }); 
// }